import { CustomStyles } from '@types';

const styles: Record<string, CustomStyles> = {
  table: {
    border: 'none',
    '& .MuiTableCell-root': {
      border: 'none',
      padding: 1,
      backgroundColor: 'transparent',
    },
    '& .MuiTableRow-root': {
      border: 'none',
      backgroundColor: 'transparent',
      verticalAlign: 'top',
    },
  },
  tableContainer: { boxShadow: 'none', mt: 1 },
};

export default styles;
